export default __webpack_public_path__ + "static/media/toggle_on.02aeb203.svg";